import BaseLayout from './base-layout';
import BaseInternalForm from './base-internal-form';

interface BaseLayoutFactoryProps {
    children: React.ReactNode;
    urlBeforeAction?: string;
}

export function BaseLayoutFactory({
    children,
    urlBeforeAction
}: BaseLayoutFactoryProps) {
    return (
        <BaseLayout>
            <BaseInternalForm>
                {children}
            </BaseInternalForm>
        </BaseLayout>
    );
}
